import type { VisitTypes } from '~/types/booking'

/**
 * Narrow what a service offers down to what a specific time slot allows.
 * `both` acts as "no restriction", so it yields to the more specific side.
 * Contradictory inputs fall back to the slot's own capability, since the
 * schedule window is the stricter source of truth.
 */
export function intersectVisitTypes(service: VisitTypes, slot: VisitTypes): VisitTypes {
  if (service === 'both') return slot
  if (slot === 'both') return service
  return service === slot ? service : slot
}
